<template>
  <svg class="img-fluid" viewBox="0 0 1020 480" ref="svg">
    <foreignObject width="1020" height="480" :style="backgroundStyle">
      <div style="width: 1020px;height: 480px;overflow: hidden" :style="safariStyleFix">
        <div class="p-0 m-0">
          <div class="container p-0 px-md-5 pt-sm-3 pt-md-5 pb-5">
            <div class="card border-0 rounded-0 shadow-lg h-100 mb-3">
              <div
                class="card-header d-flex flex-column flex-sm-row align-items-stretch bg-theme rounded-0 border-bottom align-items-sm-center p-0">
                <div v-if="election.theme.logo" class="bg-light p-3 align-self-stretch d-flex align-items-center">
                  <img :src="election.theme.logo" :alt="$t('js.accessibility.logo')" style="max-height:50px; max-width:100%" />
                </div>
                <div class="d-flex align-items-center justify-content-between p-3">
                  <h3 class="mb-0">{{ election.title[firstAvailableLocale] }}</h3>
                </div>
              </div>
              <div class="card-body h-100 p-3 p-md-5">
                <template v-if="!isBallot">
                  <template v-if="slide.layout === 'header_with_text'">
                    <header class="h1 text-center">{{ title }}</header>
                    <div class="lead mb-3 text-end" v-html="description"></div>
                  </template>
                  <template v-else-if="slide.layout === 'header_with_image'">
                    <header class="h1 text-center">{{ title }}</header>
                    <img :src="image" class="img-fluid">
                  </template>
                  <template v-else-if="slide.layout === 'single_image'">
                    <img :src="image" class="img-fluid">
                  </template>
                </template>
                <template v-if="isBallot">
                  <header class="h1 text-center">{{ title }}</header>
                  <div class="lead mb-3 text-end" v-html="description"></div>
                  <div class="ballot mt-3 text-end">
                    <ContestHeader v-for="contest in constestsInVotingRound" :contest="contest" :show-options="true"
                      :locale="firstAvailableLocale" />
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </foreignObject>
  </svg>
</template>

<script lang="ts">
import { mapState } from "pinia";
import { defineComponent } from "vue";
import ContestHeader from "@/components/shared/ContestHeader.vue";
import { orderContests } from "@/entrypoints/shared/contest_utilities";
import { useSharedStore } from "@/entrypoints/stores/shared";
import { usePresentationStore } from "@/entrypoints/stores/presentation";
import type { PropType, Slide, ConferenceContest } from "@/types";

export default defineComponent({
  name: "PreviewSlide",
  components: { ContestHeader },
  props: {
    slide: {
      type: Object as PropType<Slide>,
      required: false,
    },
  },
  data() {
    return {
      svg: {
        type: Object,
        default: null,
      },
    };
  },
  computed: {
    ...mapState(useSharedStore, ["election", "firstAvailableLocale"]),
    ...mapState(usePresentationStore, ["votingRounds", "contests"]),
    title() {
      return this.slide.title[this.firstAvailableLocale];
    },
    description() {
      return this.slide.description[this.firstAvailableLocale];
    },
    isBallot() {
      return this.slide.type === "Slides::BallotSlide";
    },
    image() {
      return this.slide.image;
    },
    safariStyleFix() {
      // @ts-ignore
      const isSafari = /constructor/i.test(window.HTMLElement.toString()) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window["safari"] || (typeof safari !== "undefined" && safari.pushNotification));
      if (isSafari) {
        const scale = (this.svg ? this.svg.clientWidth : 200) / 1020;
        return {
          "transform": `scale(${scale})`,
          "transform-origin": "top left",
        }
      }
      return {}
    },
    backgroundStyle() {
      if (this.slide.background) {
        return {
          backgroundImage: `url("${this.slide.background}")`,
          backgroundAttachment: "local",
          backgroundSize: "cover",
        };
      } else return { backgroundColor: "#fff" }
    },
    constestsInVotingRound() {
      const slideVr = this.votingRounds.find(vr => vr.reference === this.slide.votingRoundReference);
      if (!slideVr) return [];

      const slideContests = this.contests.filter((contest: ConferenceContest) =>
        slideVr.contestReferences.includes(contest.reference));
      return this.orderContests(slideContests, slideVr.contestPositions);
    },
  },
  methods: {
    orderContests,
  },
  mounted() {
    this.svg = this.$refs.svg;
  },
});
</script>
